import PropTypes from "prop-types";
import React, { useState } from "react";

function EditableTags({ tags = [], onTagsChange }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(tags.join(", "));

  const handleEdit = () => {
    setEditValue(tags.join(", "));
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleConfirm = () => {
    // Parse: split on comma, trim spaces, filter empty values
    const parsed = editValue
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);

    // Validate: all tags must start with #
    if (!parsed.every((tag) => tag.startsWith("#"))) {
      // eslint-disable-next-line no-alert
      window.alert("All tags must start with #");
      return;
    }

    // Success: call parent callback and exit edit mode
    onTagsChange(parsed);
    setIsEditing(false);
  };

  if (isEditing) {
    /* eslint-disable jsx-a11y/no-autofocus -- Focus input when entering edit mode for better UX */
    return (
      <div className="mt-2">
        <div className="mb-2">
          <input
            type="text"
            className="form-control form-control-sm"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleConfirm();
              } else if (e.key === "Escape") {
                handleCancel();
              }
            }}
            placeholder="Enter tags separated by commas (e.g., #tech, #media)"
            autoFocus
          />
        </div>
        <div>
          <button type="button" className="btn btn-sm btn-primary me-2" onClick={handleConfirm}>
            Confirm
          </button>
          <button type="button" className="btn btn-sm btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/no-autofocus */
  }

  return (
    <div>
      {tags && tags.length > 0 ? (
        <>
          {tags.map((tag) => (
            <span key={tag} className="badge rounded-pill bg-secondary me-1 mb-1">
              {tag}
            </span>
          ))}
        </>
      ) : (
        <span className="text-muted">No tags</span>
      )}
      <button
        type="button"
        className="btn btn-sm btn-link"
        onClick={handleEdit}
        title="Edit tags"
        aria-label="Edit tags"
      >
        <i className="fas fa-pencil" />
      </button>
    </div>
  );
}

EditableTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func.isRequired,
};

export default EditableTags;
